import { useQuery } from "@tanstack/react-query";

import { getFarmDetails } from "services";

import { GET_FARM_DETAILS } from "consts";

import { FarmDetailsResponse } from "models";

export const useGetFarmDetails = ({ farmId }: { farmId?: string }) =>
  useQuery<FarmDetailsResponse>({
    queryKey: [GET_FARM_DETAILS, farmId],
    queryFn: async () => {
      const data = await getFarmDetails({ farmId: farmId ?? "" });

      return {
        ...data,
        // Ensure the address fields are `null` and not `undefined`
        addressStreet: data?.addressStreet ?? null,
        addressNumber: data?.addressNumber ?? null,
        zip: data?.zip ?? null,
        addressCity: data?.addressCity ?? null,
        region: data?.region ?? null,
        country: data?.country ?? null,
      };
    },
    enabled: !!farmId && farmId.length > 0,
  });
